import { Box, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import StyledCartCards from "./StyledCartCards";
import { CREATE_NEW_TRIP } from "../../../constants/lang";

const AddTripCard = ({ onClick, tripContainerClass = "", margintop = false }) => {
  return (
    <StyledCartCards sx={{ marginTop: margintop ? "16px !important" : "0px" }}>
      <Box onClick={onClick} className={`trip-container ${tripContainerClass}`}>
        <AddIcon className="addIcon-addTrip" />
        <Box className="trip-container-text">
          <Typography className="heading-7">
            {CREATE_NEW_TRIP.heading}
          </Typography>
          <Typography className="heading-8">
            {CREATE_NEW_TRIP.subheading}
          </Typography>
        </Box>
      </Box>
    </StyledCartCards>
  )
}

export default AddTripCard;